import '@rei/cedar/dist/cdr-reset.css';
import '@rei/cedar/dist/cdr-fonts.css';
import '@rei/cedar/dist/style/cdr-link.css';
import '@rei/cedar/dist/style/cdr-list.css';
import '@rei/cedar/dist/style/cdr-text.css';
import '@rei/cedar/dist/style/cdr-container.css';

import createApp from '@not-found/main.mts';
import { getClientPageData } from '@utils/helpers.mts';

const { pageData: props } = getClientPageData();

const { app } = createApp(props);
app.mount('#app');
